import { useCallback } from 'react';
import { ragIngest, ragQuery } from '../services/rag/RagService';

export function useKnowledge() {
  const ingest = useCallback((input: Parameters<typeof ragIngest>[0]) => ragIngest(input), []);
  const query = useCallback((input: Parameters<typeof ragQuery>[0]) => ragQuery(input), []);
  return { ragIngest: ingest, ragQuery: query };
}
